/**
 * 홈 화면 최상단 상태바. 왼쪽엔 인사말("OO님, {응원 문구}")과 연속 학습일, 오른쪽엔
 * LearningStatistics(학습통계 3칸)를 둔다. StudentHome 이 이 컴포넌트를 홈 맨 위에 배치한다.
 *
 * ★ 파일명이 "MyStatics"인데 이는 MyStatistics 의 오타로 보인다. 다른 곳에서 이미
 * 이 이름으로 쓰이고 있어 파일명은 그대로 둔다(리네임 금지 지시).
 *
 * Recoil `userState` 를 직접 읽어 인사말에 쓸 이름(userData.name)을 가져온다.
 */
import React, { useEffect } from "react";
import Fire from "../icons/home/Fire";
import { useRecoilValue } from "recoil";
import { userState } from "@/recoil/atom";
import { useGetLearningStatistics } from "@/fetcher/useGetLerningStatistics";
import LearningStatistics from "./LearningStatistics";
import { useGetMaxCompletedDay } from "@/fetcher/my/useGetMaxCompletedDay";
import { useGetCheerComment } from "@/fetcher/home/useGetCheerComment";

interface MyStaticsProps {
  isTodaySolved: boolean;
}

/**
 * 홈 상태바.
 * @param isTodaySolved LearningStatistics 로 그대로 전달되지만 그쪽에서도 실제로는 쓰이지 않는다.
 */
const MyStatics: React.FC<MyStaticsProps> = ({ isTodaySolved }) => {
  const userData = useRecoilValue(userState);
  const { data } = useGetLearningStatistics();
  const { data: maxCompletedDay } = useGetMaxCompletedDay();
  const { data: cheerMessage } = useGetCheerComment();

  return (
    <article className="flex gap-x-[24px]">
      <div className="w-1/2 flex flex-col">
        <div>
          <div className="text-32">{userData.name}님,</div>
          <div className="text-32">{cheerMessage}</div>
        </div>

        <div className="flex mt-[24px]">
          <div className="flex items-center gap-x-1 px-[20px] py-[10px] bg-fill rounded-[40px]">
            <span className="text-20 text-primary font-bold  font-heading">
              {maxCompletedDay ?? "0"}일
            </span>
            <span className="text-18 text-heading font-normal">
              연속 공부 중
            </span>
            <Fire />
          </div>
        </div>
      </div>

      {/* 학습통계 컴포넌트 */}
      <div className="w-1/2">
        <LearningStatistics
          isTodaySolved={isTodaySolved}
          completedAnswerCount={data?.completedAnswerCount ?? 0}
          questionCount={data?.questionCount ?? 0}
          chapterCount={data?.chapterCount ?? 0}
        />
      </div>
    </article>
  );
};

export default MyStatics;
